import { Dispatch, SetStateAction } from 'react';
import { DynamicAlertBanner } from '../alert-banners/DynamicAlertBanner';

const AccountMigrationSuccessfull = ({
  isAccountMigrationComplete,
  setIsAccountMigrationComplete,
}: {
  isAccountMigrationComplete: boolean;
  setIsAccountMigrationComplete: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <div className="absolute bottom-8 right-4 z-50">
      <DynamicAlertBanner
        open={isAccountMigrationComplete}
        onOpenChange={setIsAccountMigrationComplete}
        icon={
          <div className="flex items-center justify-center px-[9px] py-[5px] rounded color-bg-secondary">
            <span className="text-heading-lg">💛</span>
          </div>
        }
        iconAlignment="center"
        title="Account upgrade completed"
        description={
          <div className="flex flex-col gap-1">
            <p>
              {
                'Yay! Your dDocs account has been successfully upgraded. Every document is now being migrated to your new account <3'
              }
            </p>
          </div>
        }
        variant="default"
        className="max-w-[320px] border color-border-default shadow-elevation-4 items-center"
      />
    </div>
  );
};

export { AccountMigrationSuccessfull };
